var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-dropdown",class:[_vm.type && ("c-dropdown--" + _vm.type), {'is-active': _vm.active}],on:{"click":function($event){!_vm.disabled && _vm.toggle()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }